import React, { Component } from 'react'
import {
  MessageComponentProps,
  MessageBubble,
  MessageBubbleText,
  FirebaseMessage
} from '@deal/chat-firebase'
import { Image } from '@deal/components'
import { Link } from 'react-router-dom'
import RulerPencilIcon from './ruler-pencil.svg'
import PlusIcon from './plus.svg'
import { ExpertCuratedOrderRichCardComponent, MessageRichCardType } from '#src/generated/graphql'
import styles from './styles.css'

export default class ServiceCuration extends Component<MessageComponentProps> {
  public static handlesMessage(message: FirebaseMessage) {
    return (
      message.parts[0].type == 'TEMPLATE_CAROUSEL' &&
      (message.parts[0].body.type === 'new-custom-expert-curated-order' ||
        message.parts[0].body.richCardType === MessageRichCardType.NEW_CUSTOM_CURATED_ORDER) &&
      message.parts[0].body.queryVariables &&
      message.parts[0].body.queryVariables.expertCuratedOrderId
    )
  }

  public render() {
    const { expertCuratedOrderId } = this.props.message.parts[0].body.queryVariables

    return (
      <ExpertCuratedOrderRichCardComponent variables={{ id: expertCuratedOrderId }}>
        {({ data, loading }) => {
          if (loading) {
            return (
              <MessageBubbleText message={this.props.message} myself={this.props.myself}>
                Loading...
              </MessageBubbleText>
            )
          } else if (data && data.expertCuratedOrder) {
            const { lead, items, order: { id } } = data.expertCuratedOrder

            const expert = lead.expert

            const banner = lead.category && lead.category.contentAssets.bannerImages[0]

            return (
              <MessageBubble message={this.props.message}>
                <div className={styles.hero}>
                  {banner && (
                    <Image
                      src={banner.imageUrl!}
                      width={384}
                      height={134}
                      imgixParams={{ fit: 'crop' }}
                      className={styles.heroImage}
                    />
                  )}
                  <div className={styles.overlay}>
                    <RulerPencilIcon width={48} height={48} className={styles.icon} />
                    <div>
                      {expert.firstName}
                      's custom order
                    </div>
                  </div>
                </div>

                <div className={styles.caption}>
                  <PlusIcon className={styles.plusIcon} /> {items.length}{' '}
                  {items.length === 1 ? 'item' : 'items'} in order
                </div>

                <Link to={`/orders/${id}`} className={styles.cta}>
                  View custom order
                </Link>
              </MessageBubble>
            )
          } else {
            return (
              <MessageBubbleText message={this.props.message} myself={this.props.myself}>
                Error loading messages!
              </MessageBubbleText>
            )
          }
        }}
      </ExpertCuratedOrderRichCardComponent>
    )
  }
}
